import { httpWithAuth } from '~/clients';
import { OPEN_PERSONALIZED_RECS } from '~/constants/endpoints';
import type { RecommendedVehicle } from '~/contracts/common';
import { BrowserCookies } from '~/utilities';
import {
  buildSuggestedForYouRequest,
  mapSuggestedForYouResponse
} from '~/utilities/common/requests/suggestedForYou';

type SuggestedVehiclesRequest = {
  zipCode: string;
};

export default async function fetchSuggestedVehicles(
  { zipCode }: SuggestedVehiclesRequest,
  controller: AbortController
): Promise<RecommendedVehicle[]> {
  const data = await httpWithAuth.post(
    OPEN_PERSONALIZED_RECS,
    buildSuggestedForYouRequest({
      browserCookieId: BrowserCookies.get('BrowserCookieId'),
      zip: zipCode
    }),
    {
      signal: controller.signal
    }
  );

  return mapSuggestedForYouResponse(data.data.vehicles);
}
